'use client';

/**
 * @packageDocumentation
 * @category Hook
 */

import { type AutocompleteService, createAutocompleteService } from 'BomdisoftComponents/inputs/location/google-maps';
import { PlaceType } from 'BomdisoftComponents/types';
import { useEffect, useState } from 'react';

const autocompleteService: { current: AutocompleteService | null } = { current: null };

export const usePlacePredictions = (input: string | null, selectedPlaceId?: string) => {
  const [options, setOptions] = useState<PlaceType[]>([]);

  useEffect(() => {
    let active = true;
    if (!autocompleteService.current && typeof window !== 'undefined') autocompleteService.current = createAutocompleteService(window) ?? null;
    if (!autocompleteService.current || !input) {
      setOptions([]);
      return undefined;
    }

    const timer = setTimeout(() => {
      autocompleteService.current?.getPlacePredictions({ input }, (results?: readonly PlaceType[]) => {
        if (active) setOptions(results ? results.filter(result => result.place_id !== selectedPlaceId) : []);
      });
    }, 400);

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [input, selectedPlaceId]);

  return options;
};
